import React, { createContext, useContext, useMemo } from 'react';
import { Box } from 'rebass';

import colourMatching from '../../utils/colourMatching';
import isDarkColour from '../../utils/isDarkColour';

export const variantMapPreset = {
  body: 'bodyLrg',
  'body-large': 'bodyLrg',
  'body-small': 'bodySml',
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
  a: 'link',
  link: 'link',
  'link-large': 'linkLrg',
  'link-small': 'linkSml',
  b: 'bold',
  strong: 'bold',
  bold: 'bold',
  p: 'p',
  undefined: 'bodyLrg',
};

const defaultTypographyContextValue = {
  colourScheme: 'transparent',
  variantMap: variantMapPreset,
};

export const TypographyContext = createContext(defaultTypographyContextValue);

export const TypographyContextProvider = ({
  children,
  value = {},
  ...props
}) => {
  const currentContext = useContext(TypographyContext);
  const contextValue = useMemo(
    () =>
      Object.entries(value).reduce(
        (acc, [key, val]) => {
          acc[key] = val || currentContext[key];
          return acc;
        },
        { ...defaultTypographyContextValue }
      ),
    [
      currentContext.colourScheme,
      currentContext.variantMap,
      value.colourScheme,
      value.variantMap,
    ]
  );

  const isDark = isDarkColour(contextValue.colourScheme);
  const color = isDark
    ? 'lightText'
    : colourMatching(contextValue.colourScheme) === 'transparent'
    ? 'inherit'
    : 'text';

  return (
    <TypographyContext.Provider value={contextValue}>
      <Box color={color} display="contents" {...props}>
        {children}
      </Box>
    </TypographyContext.Provider>
  );
};
